<template>
  <div style="margin-top:20px">
    <el-form
      ref="form"
      label-width="80px"
      :model="form"
    >
      <el-row style="display:none">
        <el-form-item
          label="code编码"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.code"
            :disabled="true"
          />
        </el-form-item>
      </el-row>
      <el-row style="display:none">
        <el-form-item
          label="机构编码"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.branchCode"
            :disabled="true"
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="原手机号"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.phone"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item
          label="用户姓名"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.name"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item
          label="新手机号"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.newPhone"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item
          label="新密码"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.newPwd"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item
          label="审核状态"
          style="margin-right:15px"
        >
          <el-select
            v-model="form.auditStatus"
            disabled
            placeholder="请选择"
          >
            <el-option
              label="未审核"
              :value="0"
            />
            <el-option
              label="审核通过"
              :value="1"
            />
            <el-option
              label="审核拒绝"
              :value="2"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="身份证人像面照片"
          label-width="200"
          style="margin-right:15px"
        >
          <ImgUpload
            :upload-config="{ lebal: '', prefix: 'id', form: form, suffix: 'Img', modal: false }"
            :parent-data="parentData"
          />
        </el-form-item>
        <el-form-item
          label="身份证国徽面照片"
          label-width="200"
          style="margin-right:15px"
        >
          <ImgUpload
            :upload-config="{ lebal: '', prefix: 'idBack', form: form, suffix: 'Img', modal: false }"
            :parent-data="parentData"
          />
        </el-form-item>
        <!-- <el-form-item
          label="手持身份证合照"
          label-width="200"
          style="margin-right:15px"
        >
          <ImgUpload
            :upload-config="{ lebal: '', prefix: 'idInhand', form: form, suffix: 'Img', modal: false }"
            :parent-data="parentData"
          />
        </el-form-item> -->
      </el-row>
      <el-row
        v-if="form.auditStatus == 0"
        style="float:right;margin-right:20px"
      >
        <el-button
          type="primary"
          @click="Auditpass"
        >
          审核通过
        </el-button>
        <el-button
          type="primary"
          @click="refuse"
        >
          拒绝
        </el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import request from "@/utils/request";
import { changePasswdPhoneAudit } from "@/api/authorityCreate";
import ImgUpload from "@/components/ImgUpload";

export default {
  name: "DriverDetail",
  components: {
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: true,
          areaOptions: [],
          goodsTypeList: [],
          typeOptions: [],
          vehicleDictList: [],
          bankOptions: []
        };
      }
    },
    mode: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      emptyForm: {},
      form: {
        code: "",
        branchCode: "",
        phone: "",
        name: "",
        newPhone: "",
        newPwd: "",
        auditStatus: "",
        idBackImg: "",
        idImg: "",
        idInhandImg: ""
      }
    };
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      request({
        url: `/ntocc-basic-api/changePasswdPhoneAudit/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
      });
    },
    //审核通过
    Auditpass() {
      changePasswdPhoneAudit({ code: this.form.code, auditStatus: 1 }).then(
        response => {
          this.$message({ message: response.msg, type: "success" });
          this.$emit("fatherCancelMethod", "detail");
        }
      );
    },
    //拒绝
    refuse() {
      changePasswdPhoneAudit({ code: this.form.code, auditStatus: 2 }).then(
        response => {
          this.$message({ message: response.msg, type: "success" });
          this.$emit("fatherCancelMethod", "detail");
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
</style>
